import { dateFromIso8601 } from 'app/modules/main/helper/date-from-iso-8601';

export const toDate = (
  value: Date | string
): Date | undefined => {

  if (value instanceof Date) {
    return value;
  }

  return dateFromIso8601(value);
};

export const toDateString = (
  value: Date | string | undefined
): string => {

  if (!value) {
    return '';
  }

  if (typeof value === 'string') {
    return value;
  }

  return value.toISOString();
};

export const zeroSeconds = (
  value: Date
): Date => {

  const newDate = new Date(value.getTime());

  newDate.setMilliseconds(0);
  newDate.setSeconds(0);

  return newDate;
};

export const zeroMinutes = (
  value: Date
): Date => {

  const newDate = new Date(value.getTime());

  newDate.setMinutes(0);

  return zeroSeconds(newDate);
};

export const zeroHours = (
  value: Date
): Date => {

  const newDate = new Date(value.getTime());

  newDate.setHours(0);

  return zeroMinutes(newDate);
};
